import { render } from "./SobreHome.vue?vue&type=template&id=ed3fcbe2&scoped=true"
import script from "./SobreHome.vue?vue&type=script&lang=js"
export * from "./SobreHome.vue?vue&type=script&lang=js"

import "./SobreHome.vue?vue&type=style&index=0&id=ed3fcbe2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed3fcbe2"]])

export default __exports__